import {RouterProvider, createBrowserRouter} from 'react-router'

import {AppRoutes} from './app/AppRoutes'
import {RootErrorBoundary} from './Components/errorBoundaries/RootErrorBoundary'
import {GlobalProviders} from './providers/GlobalProviders'

const router = createBrowserRouter(AppRoutes)

export const App: React.FC = () => {
  return (
    <RootErrorBoundary>
      <GlobalProviders>
        <RouterProvider router={router} />
      </GlobalProviders>
    </RootErrorBoundary>
  )
}
